import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterBar = ({ filters, onFilterChange }) => {
  const statusOptions = [
    { value: 'all', label: 'جميع الحالات' },
    { value: 'pending_review', label: 'قيد المراجعة' },
    { value: 'in_progress', label: 'قيد التنفيذ' },
    { value: 'approved', label: 'موافق عليه' },
    { value: 'rejected', label: 'مرفوض' },
  ];

  const priorityOptions = [
    { value: 'all', label: 'جميع الأولويات' },
    { value: 'urgent', label: 'عاجل' },
    { value: 'high', label: 'عالي' },
    { value: 'normal', label: 'عادي' },
  ];

  const stageOptions = [
    { value: 'all', label: 'جميع المراحل' },
    { value: 'initial_review', label: 'المراجعة الأولية' },
    { value: 'legal_review', label: 'المراجعة القانونية' },
    { value: 'final_approval', label: 'الموافقة النهائية' },
  ];

  return (
    <div className="space-y-3">
      <Input
        type="search"
        placeholder="البحث برقم العقد أو اسم العميل..."
        value={filters?.search}
        onChange={(e) => onFilterChange('search', e?.target?.value)}
      />
      <Select
        options={statusOptions}
        value={filters?.status}
        onChange={(value) => onFilterChange('status', value)}
        placeholder="تصفية حسب الحالة"
      />
      <Select
        options={priorityOptions}
        value={filters?.priority}
        onChange={(value) => onFilterChange('priority', value)}
        placeholder="تصفية حسب الأولوية"
      />
      <Select
        options={stageOptions}
        value={filters?.stage}
        onChange={(value) => onFilterChange('stage', value)}
        placeholder="تصفية حسب المرحلة"
      />
    </div>
  );
};

export default FilterBar;